import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MaskedQueryService {

  constructor() { }
  encodeParams(params: any): string {
    return btoa(JSON.stringify(params));
  }
  decodeParams(encoded: any): any {
    try {
        return JSON.parse(atob(encoded));
      } catch {
        return {};
      }
  }
  updateEncodedHashParams(params: URLSearchParams) {
    const encoded = btoa(`?${params.toString()}`);
    const url = new URL(window.location.href);
    url.hash = encoded;
    window.history.replaceState({}, '', url.toString());
  }

  getDecodedHashParams(): URLSearchParams {
    const url = new URL(window.location.href);
    const rawHash = url.hash.replace('#', '');
    if (!rawHash) return new URLSearchParams();
    let decoded = rawHash;
    try {
      decoded = atob(rawHash); // Try decode
    } catch {
      // If not Base64, keep raw string
    }

    return new URLSearchParams(decoded.replace('?', ''));
  }

}
